const USE_AI_COUNT_BUTTON_STYLE = {
    backgroundColor: '#ffffff',
    padding: '6px 11px',
    fontSize: '11.5px',
    fontWeight: 600,
    color: '#1A2744',
    border: '1px solid #DEE2E6',
};

export default function UseAiCountButton({
    aiCount = null,
    disabled = false,
    onClick,
    title,
}) {
    const isDisabled = disabled || aiCount == null;
    const label = aiCount != null
        ? `Use Estimated Capacity (${aiCount})`
        : 'Use Estimated Capacity';

    return (
        <button
            type="button"
            disabled={isDisabled}
            className={
                isDisabled
                    ? 'inline-flex items-center rounded cursor-not-allowed'
                    : 'inline-flex items-center rounded hover:bg-gray-50 transition-colors'
            }
            style={{
                ...USE_AI_COUNT_BUTTON_STYLE,
                ...(isDisabled ? { color: '#ADB5BD' } : {}),
            }}
            title={title ?? (isDisabled && aiCount == null ? 'Available once geofence enrichment finishes' : undefined)}
            onClick={() => {
                if (!isDisabled && onClick) onClick(aiCount);
            }}
        >
            {label}
        </button>
    );
}
